import { AssetAmount } from "@sundaeswap/asset";
import { useLocation } from "@tanstack/react-location";
import { FC, PropsWithChildren, Suspense, useMemo } from "react";
import { ADA_METADATA } from "../../constants/cardano.constants";
import { useTasteTestByPolicyId } from "../../gql/hooks/taste-test.query";
import { OrderContextProvider } from "../../stores/OrderContext";
import { IAssetMetaData } from "../../types/Asset.types";
import { getTasteTestPolicyId } from "../../utils/taste-test.utils";
import TasteTestDetailSkeleton from "./TasteTestDetail.skeleton";
import { TasteTestDetailContextProvider } from "./context";

const TasteTestDetailWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { current } = useLocation();
  const currentTasteTestPolicyId = getTasteTestPolicyId(current.pathname);
  const tasteTestByPolicyIdQuery = useTasteTestByPolicyId(currentTasteTestPolicyId);
  const { data: activeTasteTest, isLoading } = tasteTestByPolicyIdQuery;

  const given = new AssetAmount<IAssetMetaData>(0, ADA_METADATA);
  const taken = new AssetAmount<IAssetMetaData>(
    0,
    activeTasteTest?.asset as unknown as IAssetMetaData
  );

  const forcedSeed = useMemo(
    () =>
      activeTasteTest && {
        assets: {
          given,
          taken,
        },
        flowData: {
          syncSearch: false,
        },
      },
    [activeTasteTest]
  );

  if (isLoading) return <TasteTestDetailSkeleton />;

  return (
    <Suspense fallback={<TasteTestDetailSkeleton />}>
      <OrderContextProvider seed={forcedSeed}>
        <TasteTestDetailContextProvider tasteTestByPolicyIdQuery={tasteTestByPolicyIdQuery}>
          {children}
        </TasteTestDetailContextProvider>
      </OrderContextProvider>
    </Suspense>
  );
};

export default TasteTestDetailWrapper;
